export default __webpack_public_path__ + "static/media/quadrilateral.955a454f.webp";